angular.module('SpidApp')

.controller('StockFlowsHistoryController', 
          ['$scope', '$stateParams', 'StockFlowService', 'StockFlowManager', 'MonthStockLineChartGenerator', 'YearStockLineChartGenerator', '$timeout'
, function ($scope,   $stateParams,   StockFlowService,   StockFlowManager,   MonthStockLineChartGenerator,   YearStockLineChartGenerator,   $timeout) {
              	
    if (!$stateParams.historyAgencyId) {
        throw "StockFlowsController() - You didn't provide an agencyId for stock history"   
    }
    
    var reloadController = function(historyAgencyId) {
    	var agencyId = historyAgencyId
        
        $scope.monthHistoryChartLoaded = false;
        $scope.isMonthProductHistory   = true;
        $scope.isMonthProductOpHistory = true;
        
        $scope.date =  new Date()
        
        StockFlowService.allByAgencyIdAndMonth(agencyId, $scope.date.toISOString()).then(function (stockflows) {
        	var stockflowsProducts = StockFlowManager.getReverseStockFlowsByProductGroupByOrderableId($scope.stockProducts, stockflows);
        	$scope.monthProductHistoryChart = new MonthStockLineChartGenerator(stockflowsProducts).get();
        	
        	var stockflowsProductsOp = StockFlowManager.getReverseStockFlowsByProductGroupByOrderableId($scope.stockOpProducts, stockflows);
        	$scope.monthProductOpHistoryChart = new MonthStockLineChartGenerator(stockflowsProductsOp).get();
        }).finally(function() {
        	$scope.monthHistoryChartLoaded = true;
        });
            
        StockFlowService.allByAgencyIdAndYear(agencyId, $scope.date.toISOString()).then(function (stockflows) {
        	var stockflowsProducts = StockFlowManager.getReverseStockFlowsByProductGroupByOrderableId($scope.stockProducts, stockflows);
        	$scope.yearProductHistoryChart = new YearStockLineChartGenerator(stockflowsProducts).get();
        	
        	var stockflowsProductsOp = StockFlowManager.getReverseStockFlowsByProductGroupByOrderableId($scope.stockOpProducts, stockflows);
        	$scope.yearProductOpHistoryChart = new YearStockLineChartGenerator(stockflowsProductsOp).get();
        });
    }
    reloadController($stateParams.historyAgencyId)
    
    $scope.getProductHistory = function(month) {
    	$scope.isMonthProductHistory = true;
    	if (!month) {
    		$scope.isMonthProductHistory = false;
    	}
    }
    
    $scope.getProductOpHistory = function(month) {
    	$scope.isMonthProductOpHistory = true;
    	if (!month) {
    		$scope.isMonthProductOpHistory = false;
    	}
    }
    
    $scope.printStockHistory = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
		$timeout(function() {
    		window.print();
    	}, 50);
	} 
    
    $scope.$on('changeAgencyEvent', function(event, args) {
    	reloadController(args.agencyId)
    });
}])
